import { useEffect, useState } from 'react'
import Header from '../../components/Header'
import { Outlet, useLocation } from 'react-router-dom'
import MobileBottomNavbar from '../../components/Header/MobileBottomNavbar'
import { subscribeToGreyhoundMatchesData, subscribeToHorseMatchesData, subscribeToMatchData } from '../../../socketClient';
import CasinoHome from '../../components/CasinoHome';
import { isMobile } from 'react-device-detect';
import QuickLinks from '../QuickLinks';
import useTrackPreviousRoute from '../../../hooks/useTrackPreviousRoute';
import { themeColors } from '../../utils/themeColors';

function Home() {
  const location = useLocation();

  useEffect(() => {
    // Subscribe to all matches for each sport
    subscribeToMatchData({
      eventId: 4, // Cricket
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "cricket",
    });
    subscribeToMatchData({
      eventId: 1, // Soccer (fixed order to match your backend convention)
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "soccer",
    });
    subscribeToMatchData({
      eventId: 2, // Tennis
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "tennis",
    });
    subscribeToGreyhoundMatchesData();
    subscribeToHorseMatchesData();
  }, []);


  useEffect(() => {
    const previousPadding = document.body.style.paddingBottom;
    document.body.style.paddingBottom = "0px";
    // document.body.style.backgroundColor = "#ededed";

    // return () => {
    //   document.body.style.paddingBottom = previousPadding;
    // };
  }, []);
  useTrackPreviousRoute();
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") return true;
    if (savedTheme === "light") return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });


  const [selectedTheme, setSelectedTheme] = useState(() => {
    const savedTheme = localStorage.getItem("themeData");
    return savedTheme ? JSON.parse(savedTheme) : themeColors.find((t) => t.id === "theme1");
  });
  // Sync theme and dark mode with localStorage and DOM
  useEffect(() => {
    localStorage.setItem("themeData", JSON.stringify(selectedTheme));
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
    document.documentElement.classList.toggle("dark", isDarkMode);
  }, [selectedTheme, isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };



  return (
    <div className="bg-light-bg dark:bg-dark-bg" style={{ display: "flex", flexDirection: "column", position: "relative" }}>
      <div className='h-[56px] w-full' />
      <Header />
      {/* <div className='w-full flex flex-row'>
        {!isMobile && <div className='w-[25%] flex'>
          <QuickLinks />

        </div>} */}
        <div className='sticky top-[56px]' style={{ scrollMargin: "56px", scrollSnapMarginTop: "56px", scrollMarginBottom: "56px", scrollSnapMarginBottom: "56px" }}>
          {
            !"/live-casino, /lottery".includes(location.pathname) &&
            (<div className={!"/inplay, /sports, /horseRacing".includes(location.pathname) ? "border-b-[3px] border-[#265e04]" : ""}
              style={{ height: "/inplay, /sports, /horseRacing".includes(location.pathname) ? "100%" : "70vw", maxHeight: "/inplay, /sports, /horseRacing".includes(location.pathname) ? "100%" : "320px", overflowY: "auto" }}
            >
              <Outlet />
            </div>)
          }
          {
            !"/sports, /inplay".includes(location.pathname) &&
            (<div
            // style={{ height: "calc(100vh - 112px)", overflowY: "auto" }}
            >
              <CasinoHome />
            </div>)
          }

          {isMobile && <div className='h-[70px] w-full' />}
        </div>
      {/* </div> */}

      {isMobile && <div className='w-full mt-4' style={{ position: "fixed", bottom: 0, }} >
        <MobileBottomNavbar />
      </div>}
    </div>
  )
}

export default Home